'use client';

import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import { BrandMark } from '@/components/ui/BrandMark';

export default function NotFoundClient() {
  const t = useTranslations('notFound');

  return (
    <main data-theme="dark" className="min-h-screen bg-bg text-ink grid place-items-center p-4">
      <div className="max-w-md w-full bg-panel border border-line rounded-2xl p-8 text-center">
        <BrandMark size={72} className="mx-auto mb-6" />
        <div className="font-display text-5xl text-accent mb-2">404</div>
        <h1 className="font-display text-xl mb-3">{t('title')}</h1>
        <p className="text-muted text-sm mb-8">{t('description')}</p>
        <Link
          href="/"
          className="inline-block px-5 py-2.5 rounded-lg font-bold bg-accent text-onbright hover:opacity-90 transition"
        >
          {t('goHome')}
        </Link>
      </div>
    </main>
  );
}
